import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import AlertComponent from "../../components/AlertComponent";
import Loading from "../../components/Loading";

export default function GrupoForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  const [dadoGrupo, setDadoGrupo] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(isEdit);


  useEffect(() => {
    if (isEdit) {
      axios
        .get(`${process.env.REACT_APP_API}/grupos/${id}`)
        .then((res) => {
          const data = res.data.data;
          setDadoGrupo(data.nome || "");
        })
        .catch((err) => {
          console.error(err);
          AlertComponent("Erro", "Erro ao carregar grupo", { icon: "error" });
        })
        .finally(() => setLoadingData(false));
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    const { value } = e.target;
    setDadoGrupo(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        nome: dadoGrupo
      };

      if (isEdit) {
        await axios.put(`${process.env.REACT_APP_API}/grupos/${id}`, payload);
        AlertComponent("Sucesso", " Grupo salvo com sucesso!", { icon: "success" });
      } else {
        await axios.post(`${process.env.REACT_APP_API}/grupos`, payload);
      }
      navigate(`/grupos?filtro=${encodeURIComponent(dadoGrupo)}`);
    } catch (error) {
      console.error("Erro ao salvar grupo:", error);
      AlertComponent("Erro", error?.response?.data?.message ?? "Erro ao salvar grupo", { icon: "error" });
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) return <Loading />;

  return (
    <div className="w-full">
      {/* HEADER */}
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-slate-800">
          {isEdit ? "Editar Grupo" : "Novo Grupo"}
        </h1>
        <p className="text-sm text-slate-500">
          {isEdit
            ? "Atualize as informações do grupo"
            : "Preencha as informações para criar um novo grupo"}
        </p>
      </div>

      {/* FORMULÁRIO */}
      <form onSubmit={handleSubmit}>
        <div className="bg-white p-8 rounded-xl shadow border">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nome
              </label>
              <input
                type="text"
                name="nome"
                value={dadoGrupo}
                onChange={handleChange}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
                placeholder="Digite o nome do grupo"
                required
                disabled={loading}
              />
            </div>
          </div>
        </div>

        {/* AÇÕES */}
        <div className="mt-10 flex justify-end gap-3 border-t pt-6">
          <button
            type="button"
            onClick={() => navigate("/grupos")}
            className="px-5 py-2 rounded-md border hover:bg-gray-50 disabled:opacity-50"
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            type="submit"
            className="px-6 py-2 rounded-md bg-slate-900 text-white hover:bg-slate-800 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? "Salvando..." : isEdit ? "Salvar alterações" : "Criar grupo"}
          </button>
        </div>
      </form>
    </div>
  );
}